/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AbstractFinderDialogComponent } from '@gh/common-internal-shared';
import { observableBasedSlicedDataSource, SlicedDataSource } from '@gh/core-data';
import { TranslationService } from '@gh/core-mls';
import { WaitingService } from '@gh/core-ui';
import { GridComponent } from '@gh/core-ui-grid';
import { findIndex } from 'lodash';
import {
  AccountingAccount,
  AccountingAccountFinderDialogConfig,
  getAccountingAccountId,
  SystemVarsAccountingBusinessService,
} from '../../../resources';
import { AccountingAccountDialogGridDefinitionService } from './accounting-account-dialog-grid-definition.service';
import { of$ } from '@gh/rx';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  standalone: false,
  selector: 'gh-accounting-account-finder-dialog',
  templateUrl: 'accounting-account-dialog.component.html',
  styleUrls: ['accounting-account-dialog.component.scss'],
  providers: [AccountingAccountDialogGridDefinitionService],
})
export class AccountingAccountDialogComponent
  extends AbstractFinderDialogComponent<AccountingAccountFinderDialogConfig, AccountingAccount>
  implements OnInit {

  @ViewChild(GridComponent, { static: false }) grid: GridComponent;
  getId = getAccountingAccountId;
  defaultTitle = this.translations.get('lbl_xero_chart_of_accounts');
  isLoading: boolean;
  accounts$: Observable<AccountingAccount[]>;
  _accounts = new BehaviorSubject<AccountingAccount[]>([]);
  constructor(
    public gridDefinition: AccountingAccountDialogGridDefinitionService,
    private translations: TranslationService,
    private waitingService: WaitingService,
    private dialogRef: MatDialogRef<any>,
    private businessService: SystemVarsAccountingBusinessService,
  ) {
    super(dialogRef);
    this.accounts$ = this._accounts.asObservable();
  }
  ngOnInit(): void {
    super.ngOnInit();
    const { accountClass, tmpCredentials } = this.input;
    this.isLoading = true;
    this.businessService.findAll(
      {
        class: accountClass,
        tmpCredentials,
      }).subscribe((res) => {
        this.isLoading = false;
        if (this.input.exclude) {
          this._accounts.next(res.filter((account) => -1 === findIndex(
            this.input.exclude,
            (excludeAccount) => excludeAccount.code === account.code
              && excludeAccount.externalId === account.externalId,
          ))) ;
        } else {
          this._accounts.next(res);
        }
      },
                   () => this.isLoading = false);
  }
  protected buildDataSource(): SlicedDataSource<AccountingAccount> {
    return observableBasedSlicedDataSource(of$());
  }

  protected isSelectable(account: AccountingAccount): boolean {
    return !account.groupTitle;
  }
}
